// extracted by mini-css-extract-plugin
export var fileContent = "styles-module--fileContent--9ff5d";
export var link = "styles-module--link--41f90";
export var pdfDownload = "styles-module--pdfDownload--5a388";